// Types
import type { TManagerCompanyPart } from '~/modules/manager/company/types';
import { EManagerCompanyView } from '~/modules/manager/company/types';

const MANAGER_COMPANY_PARTS: TManagerCompanyPart[] = [
  {
    key: EManagerCompanyView.AGENCY,
    label: 'Agency',
  },
  {
    key: EManagerCompanyView.USERS,
    label: 'Users',
  },
  {
    key: EManagerCompanyView.AREAS,
    label: 'Areas',
  },
  {
    key: EManagerCompanyView.SOURCES,
    label: 'Sources',
  },
  {
    key: EManagerCompanyView.TOOLS,
    label: 'Tools',
  },
  {
    key: EManagerCompanyView.MARKET_APPRAISALS,
    label: 'Market appraisals',
    requiresExternal: true,
  },
  {
    key: EManagerCompanyView.UPLOAD_ADDRESSES,
    label: 'Upload addresses',
  },
  {
    key: EManagerCompanyView.STATS,
    label: 'Stats',
  },
  {
    key: EManagerCompanyView.EXTERNAL_OFFICES,
    label: 'Ext. Offices',
    requiresExternal: true,
  },
  {
    key: EManagerCompanyView.OPPORTUNITY_LOOKUP,
    label: 'Opportunity Lookup',
    excludeKeepAlive: true,
  },
  {
    key: EManagerCompanyView.GLOBAL_FILTERS,
    label: 'Global Filters',
  },
  {
    key: EManagerCompanyView.MERGE,
    label: 'Merge',
  },
];

export { MANAGER_COMPANY_PARTS };
